import BaseStateSprite from "../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../define/MessageEventKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import gamblerGame from "./gamblerGame";
import { gamblerEndInterface, gamblerEventInterface, gamblerStartInterface, TreasureMapCollect } from "./gamblerGameConst";
import gamblerGameObj from "./gamblerGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class gamblerGameClean extends cc.Component {

    cleanNode:cc.Node = null;

    gameScript:gamblerGame = null;

    @property(cc.Node)
    nodeWood: cc.Node = null;

    @property(BaseStateSprite)
    sprResult: BaseStateSprite = null;

    @property({type:cc.Node,displayName:"top节点"})
    topNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    explainLb:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    nameLb:cc.Label = null;

    @property({type:cc.Label,displayName:"估价文本"})
    lbPrice:cc.Label = null;

    @property(cc.Sprite)
    nodeGoods: cc.Sprite = null;

    // @property({type:cc.Label,displayName:"品级文本"})
    // levelLb:cc.Label = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    @property(cc.Node)
    btnPushBackpack: cc.Node = null;

    startData:gamblerStartInterface = null;
    endData:gamblerEndInterface = null;

    showNode:cc.Node = null;

    buyCoin:number = 0;
    sellCoin:number = 0;

    specialEvent:gamblerEventInterface = {
        id: "100001",
        event_category: 6,
        trigger_pro: 0,
        event_description: "居然是一个金元宝！招财猫最喜欢了，快去找它吧！",
        event_option1: "膜拜",
        event_option2: "放弃",
        option1Param: {addBackPack:""},
        option2Param: undefined,
        result: "",
        result_money: 0,
        result_pro: 0
    }

    start(){
        this.nodeGoods.node.active = false;
        this.updatePage();
        let tween = cc.tween(this.lightNode).by(3,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        })
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    bindNode(node:cc.Node,gameScript:gamblerGame){
        this.cleanNode = node;
        this.cleanNode.removeFromParent(false);
        this.cleanNode.parent = this.node;
        this.cleanNode.active = false;
        this.gameScript = gameScript;
    }

    async showGoods(goodsId: number) {
        if (!goodsId) {
            return;
        }
        this.sprResult.setFill(false);
        this.btnPushBackpack.active = true;
        this.nodeGoods.node.active = false;
        let backConfig = backPackEventMap()[goodsId];
        this.nameLb.string = backConfig.name;
        this.sellCoin = backConfig.sellPrice;
        this.lbPrice.string = data_control.getNumberFormat(this.sellCoin);
        // 没有事件 按照正常流程结算
        this.setExplain(backConfig.details);

        if(backConfig){
            let objPath:string = backConfig.spPath;
            let iconPath = "backpackAssets/objSp/" + objPath;
            let bundlePb = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
            bundlePb.load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.nodeGoods.node.active = true;
                        this.nodeGoods.spriteFrame = imgs;
                    }
                }
            );
        }
    }

    updatePage(){
        if(this.cleanNode && this.cleanNode.isValid){

            let priceRate = NormalGameManager._instance.getPriceRate();
            let os = this.cleanNode.getComponent(gamblerGameObj);
            this.startData = os.startData;
            this.buyCoin = this.startData.price;
            let endData = this.endData = os.endData;
            this.sellCoin = Math.floor(endData.price * priceRate);

            // let certain = endData.certain;
            // let event:gamblerEventInterface = null; 
            // let events:number[] = endData.Emergency;
            let describe = endData.describe;
            let woodname = endData.woodname;
            if (os.goodsId) {
                O1HD.getManagers().soundMgr.playSound("openTreasure").then();
                this.showNode = null;  
                this.showGoods(os.goodsId);
            } else {
                this.btnPushBackpack.active = false;
                this.showNode = this.loadNormalNode();
                // this.showNode.y = -66.22;
                // this.showNode.scale = 0.9;
                this.nameLb.string = woodname;
                this.lbPrice.string = data_control.getNumberFormat(this.sellCoin);
                // 没有事件 按照正常流程结算
                this.setExplain(describe);
            }
            this.sprResult.setFill(this.buyCoin >= this.sellCoin);
            
             // console.log("触发>>>>>",this.showNode);
            //  this.updateNormalBtns();
             

            // console.log(certain,">>>>>>>")
            // if(certain == 1){
            //     // 会必定触发事件
            //     event = this.getRandEvent(events);
            //     this.showNode = this.loadEventNode(event);
            //     // console.log("触发>>>>>",this.showNode);
            //     this.setExplain(event.event_description);
            //     this.updateEventBtns();
            // }else{
            //     // 按照设定的概率来
            //     let rand = Math.random();
            //     // console.log(rand,"随机值",gameConfig.GAMBLER_SPECIAL_EVENT_PRO)
            //     if( rand < gameConfig.GAMBLER_SPECIAL_EVENT_PRO){
            //         event = this.specialEvent;
            //         this.event = this.specialEvent;
            //         this.showNode = this.loadEventNode(event);
            //         this.setExplain(event.event_description);
            //         this.updateEventBtns();
            //     }else if(Math.random() < gameConfig.GAMBLER_EVENT_PRO && events.length>0){
            //         // 有事件 按照权重来
            //         event = this.getRandEvent(events);
            //         this.showNode = this.loadEventNode(event);
            //         this.setExplain(event.event_description);
            //         this.updateEventBtns();
            //     }else{
                   
            //         // this.levelLb.string = endData.level;
            //     }
            // }
            if(this.showNode){
                this.showNode.setParent(this.nodeWood);
                this.showNode.setPosition(cc.v2(0,0));
            }
        }
    }

    getRanEndLuckyData(ys_id:string){
        // let luckyEndData = this.gameScript.gamblerLuckyEndMap;
        // let ary:gamblerEndInterface[] = [];
        // for(let key in luckyEndData){
        //     let k = luckyEndData[key];
        //     if(k.ys_id == ys_id){
        //         ary.push(k);
        //     }
        // }
        // return data_control.getRandItemOfArray(ary);
    }

    event:gamblerEventInterface = null;

    getRandEvent(events:number[]){
        // let eventMap = this.gameScript.gamblerEventMap;
        // let weightAry:number[] = [];
        // let eventAry:gamblerEventInterface[] = [];
        // for(let i = 0;i<events.length;i++){
        //     let e = events[i];
        //     for(let k in eventMap){
        //         let ee = eventMap[k]
        //         let pro = ee.trigger_pro;
        //         if(ee.event_category == e){
        //             eventAry.push(ee);
        //             weightAry.push(pro);
        //         }
        //     }

        // }
        // let randIndex = data_control.getRandIPosByWeights(weightAry);
        // let tEvent = eventAry[randIndex];
        // this.event = tEvent;
        // return tEvent;
    }

    //更新事件按钮
    updateEventBtns(){
        // this.eventBtnLayout.active = true;

        // let oneOption = this.event.event_option1;
        // let twoOption = this.event.event_option2;

        // let strs = [oneOption,twoOption];

        // this.eventBtnLayout.children.forEach((n:cc.Node,index:number)=>{
        //     let str = strs[index];
        //     let lb:cc.Label = n.getChildByName("layout").getChildByName("lb").getComponent(cc.Label);
        //     if(str != ""){
        //         n.active = true;
        //         lb.string = str;
        //     }else{
        //         n.active = false;
        //     }
        //     let video:cc.Node = n.getChildByName("layout").getChildByName("video");
        //     if(this.event.event_category!=3 && index == 0){
        //         video.active = false;
        //     }else if(this.event.event_category == 3 && index == 0){
        //         video.active = false;
        //         this.optionEventHasVideo[0] = false;
        //     }
        // });
        

    }

    optionEventHasVideo:boolean[] = [false,false];

    //更新普通按钮
    updateNormalBtns(){
        // this.normalBtnLayout.active = true;
        // let btn:cc.Node = this.normalBtnLayout.children[0];
        // let label = btn.getChildByName("layout").getChildByName("lb_money").getComponent(cc.Label);
        // label.string = data_control.getNumberFormat(this.endData.price);
    }

    // onBtnSell(e:cc.Event.EventTouch){
    //     O1HD.getManagers().soundMgr.playSound("anNiu");
    //     let targetNode:cc.Node = e.target;
    //     let coin = this.endData.price;
    //     O1HD.getServices().userSrv.setCoins(coin,true,targetNode);
    //     this.closeThis();
    // }

    onBtnSell(event: cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.doSell(event.target);
    }

    doSell(node: cc.Node, scale: number = 1) {
        let price:number = this.sellCoin * scale;
        O1HD.getServices().userSrv.setCoins(price,true, node);
        this.closeThis();
    }

    onClickDoubleSell(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.doSell(event.target, 2);
        },()=>{

        },null,"切木头观看视频双倍卖出");
    }

    onClickPushBackpack() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let os = this.cleanNode.getComponent(gamblerGameObj);
        let goodsId = os.goodsId;
        if(goodsId){
            let t = TreasureMapCollect;
            let nidx = t.indexOf(goodsId);
            let gameData = NormalGameManager._instance.getGameData();
            if (nidx != -1) {
                if (!gameData.treasureMap[nidx]) {
                    let pPos = this.btnPushBackpack.convertToWorldSpaceAR(cc.v2());
                    O1HD.emit(MessageEventKind.EventName.TREASURE_MAP_COLLECT_ANI, nidx, pPos);
                }
            }
            NormalGameManager._instance.onPushGoods(goodsId, 1);
        }
        // this.openPage && this.openPage.destroy();
        // this.openPage && this.openPage.removeFromParent();
        this.closeThis();
    }

    onBtnEventSell(e:cc.Event.EventTouch){
        let coin = this.event.result_money;
        let targetNode:cc.Node = e?.target || this.node;
        if(coin!=0){
            O1HD.getServices().userSrv.setCoins(coin,true,targetNode); 
        }
        this.closeThis();
    }

    updateEventSellBtn(){
        // this.eventSellBtn.active = true;
        // let label = this.eventSellBtn.getChildByName("layout").getChildByName("lb_money").getComponent(cc.Label);
        // label.string = data_control.getNumberFormat(this.event.result_money);
    }

    onBtnOption(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let isHaveVideo:boolean = this.optionEventHasVideo[Number(custom)];
        if(isHaveVideo){
            utilsModel.loadAndShowVideoAdTrans(()=>{
                if(custom == "0"){
                    let param = this.event.option1Param;
                    if(param){
                        let backPackId:number = param["addBackPack"];
                    }
                    this.startEndAni();
                }else{
                    this.closeThis();
                }
            },()=>{

            },null,"赌木看广告");
        }else{
            if(custom == "0"){
                // let coin = this.event.result_money;
                // if(coin!=0){
                //     O1HD.getServices().userSrv.setCoins(coin,true,targetNode); 
                // }
                let param = this.event.option1Param;
                if(param){
                    let backPackId:number = param["addBackPack"];
                }
                this.startEndAni();
            }else{
                this.closeThis();
            }
        }
    }

    async setExplain(str:string){
        this.explainLb.string = "";
        return new Promise<void>(async resolve=>{
            for(let i = 0;i<str.length;i++){
                this.explainLb.string += str[i];
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,0.02);
                });
            }
            resolve();
        });
    }

    async startEndAni(){
        // let aniNode:cc.Node = this.showNode?.getChildByName("ani");
        // if(aniNode){
        //     let animation = aniNode.getComponent(cc.Animation);
        //     animation.play();
        // }
        // if(!this.event.result || this.event.result == ""){
        //     this.closeThis();
        //     return;
        // }
        // this.updateEventSellBtn();
        // this.normalBtnLayout.active = false;
        // this.eventBtnLayout.active = false;
        // await this.setExplain(this.event.result);
    }

    closeThis(){
        // this.normalBtnLayout.active = false;
        // this.eventBtnLayout.active = false;
        this.cleanNode?.destroy();
        this.cleanNode?.removeFromParent();
        this.node.destroy();
        this.node.removeFromParent();
    }

    loadNormalNode(){
        let sp = this.endData.incision;
        let prefab:cc.Prefab = null;
        switch(sp){
            case 1:{
                prefab = this.resultPrefabs[0];
                break;
            }
            case 2:{
                prefab = this.resultPrefabs[1];
                break;
            }
            case 3:{
                prefab = this.resultPrefabs[2];
                break;
            }
            case 4:{
                prefab = this.resultPrefabs[4];
                break;
            }
            case 5:{
                prefab = this.resultPrefabs[3];
                break;
            }
            case 6:{
                prefab = this.resultPrefabs[5];
                break;
            }
            case 7:{
                prefab = this.resultPrefabs[6];
                break;
            }
        }
        return cc.instantiate(prefab);
    }

    @property({type:cc.Prefab,displayName:"结果预制体"})
    resultPrefabs:cc.Prefab[] = [];

    loadEventNode(event:gamblerEventInterface){
        let type = event.event_category;
        let prefab:cc.Prefab = null;
        switch(type){
            case 1:{
                prefab = this.resultPrefabs[7];
                break;
            }
            case 2:{
                prefab = this.resultPrefabs[8];
                break;
            }
            case 3:{
                prefab = this.resultPrefabs[9];
                break;
            }
            case 4:{
                prefab = this.resultPrefabs[10];
                break;
            }
            case 5:{
                prefab = this.resultPrefabs[11];
                break;
            }
            case 6:{
                prefab = this.resultPrefabs[12];
                break;
            }
            default:{
                prefab = this.resultPrefabs[0];
                break;
            }
        }
        return cc.instantiate(prefab);
    }
    
}
